module.exports = __webpack_public_path__ + "img/OVEN_AMENITY.fe04d206.svg";